import { render, staticRenderFns } from "./PagoCliente.vue?vue&type=template&id=0bfa559e&scoped=true"
import script from "./PagoCliente.vue?vue&type=script&lang=js"
export * from "./PagoCliente.vue?vue&type=script&lang=js"
import style0 from "./PagoCliente.vue?vue&type=style&index=0&id=0bfa559e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfa559e",
  null
  
)

export default component.exports